import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { splitConsentWording } from '../constants/consent';
// Renders consent wording with its lead sentence in bold.
export const ConsentText = ({ wording }) => {
    const { lead, rest } = splitConsentWording(wording);
    return (_jsxs(_Fragment, { children: [lead && _jsx("strong", { className: "ls-emphasis", children: lead }), rest] }));
};
